import { useState, useEffect } from 'react';
import { ActionButton } from '../../../common/Buttons/Buttons';
import canje from '../../../../images/canje.svg';
import { capitalize, returnIGTF } from '../../../../assets/helpers/funciones';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import './LandingForms.scss';

export const SuccesPurchase = (props) => {
  const [user, setUser] = useState('');
  const [payment, setPayment] = useState('');
  const [vehicle, setVehicle] = useState('');

  const { affiliationType } = useParams();

  const preloadData = () => {
    let userData = sessionStorage.getItem('personalData');
    let paymentData = sessionStorage.getItem('payment');
    let vehicleData = sessionStorage.getItem('vehicle');
    userData = JSON.parse(userData);
    paymentData = JSON.parse(paymentData);
    vehicleData = JSON.parse(vehicleData);

    setUser(userData);
    setPayment(paymentData);
    setVehicle(vehicleData);
  };

  const finish = () => {
    window.location.reload();
    sessionStorage.removeItem('personalData');
    sessionStorage.removeItem('payment');
    sessionStorage.removeItem('vehicle');
  };

  useEffect(() => {
    preloadData();
  }, []);

  if (!user || !vehicle) {
    return null;
  } else {
    return (
      <>
        <div className="landing-form-container">
          <img src={canje} alt="" />
          <h2>{["F2", "F4"].includes(affiliationType) ? "¡Registro exitoso!" : "¡Compra exitosa!"}</h2>
          <p>{["F2", "F4"].includes(affiliationType) ? "Resumen de Información" : "Resumen de Compra"}</p>
          <br />
          <div className="purchase-container">
            <PurchaseSection
              label={'Fecha de Compra'}
              text={moment(new Date()).format('DD-MM-YYYY')}
            />
            <PurchaseSection
              label={'Nombre'}
              text={`${user?.firstName}  ${user?.lastName}`}
            />
            <PurchaseSection label={'E-mail'} text={`${user?.email}`} />
            <PurchaseSection
              label={'Dirección'}
              text={`${capitalize(vehicle?.stateName)}, ${capitalize(
                vehicle?.cityName
              )}, ${capitalize(vehicle?.municipalityName)} ${capitalize(
                vehicle?.address
              )}`}
            />{' '}
            <PurchaseSection
              label={'Vehículo '}
              text={`${capitalize(vehicle?.modelName)} ${capitalize(vehicle?.brandName)} ${vehicle?.year} ${capitalize(vehicle?.color)} ${vehicle?.plate}`}
            />
            {payment && (
              <div>
                <PurchaseSection
                  label={'Tipo de pago'}
                  text={`${payment?.paymentType}`}
                />
                <PurchaseSection
                  label={'Cantidad de Pagos'}
                  text={payment?.allPayments?.length}
                />
                <PaymentSection
                  label={'Método de pago'}
                  payments={payment?.allPayments}
                />
                <TotalSection label={'TOTAL'} payments={payment?.allPayments} />
              </div>
            )}
          </div>

          <div
            style={{ margin: '24px 0px 48px 0px' }}
            className="buttons-center-container"
          >
            <ActionButton label={'Finalizar'} action={() => finish()} />
          </div>
        </div>
      </>
    );
  }
};

export const PurchaseSection = (props) => {
  const { label, text } = props;

  if (label && text) {
    return (
      <div className="purchase-section-component">
        <h6>{label}</h6>
        <h6>{text}</h6>
      </div>
    );
  } else return null;
};

export const TotalSection = (props) => {
  const { label, payments } = props;

  let totalPrice = 0;
  let iftg = false;

  // if (payments?.length > 1) {
  for (let i = 0; i < payments.length; i++) {
    if (payments[i]?.currency !== 'BsS') {
      totalPrice =
        totalPrice + payments[i]?.amount + payments[i]?.amount * returnIGTF() / 100;
      iftg = true;
    } else {
      totalPrice = totalPrice + payments[i]?.amount;
    }
    // }
  }
  totalPrice = totalPrice.toFixed(2);

  if (label && payments) {
    return (
      <div className="purchase-section-component">
        <h6>{label}</h6>
        <h6>
          ${totalPrice} {iftg ? ` Incluye IGTF (${returnIGTF()}%)` : ''}
        </h6>
      </div>
    );
  } else return null;
};

export const PaymentSection = (props) => {
  const { label, payments } = props;

  if (label && payments) {
    return (
      <div className="purchase-section-component">
        <h6>{label}</h6>
        {/* <h6>{payments?.map()}</h6> */}
        <h6 style={{ textAlign: 'right' }}>
          {payments?.map((p) => (
            <span key={p?.method}>
              {capitalize(p?.methodName) +
                '  ' +
                (p?.currency === 'BsS'
                  ? p?.amountBsS + ' ' + p?.currency
                  : parseFloat(p?.amount) +
                  parseFloat(p?.amount) * returnIGTF() / 100 +
                  ' ' +
                  p?.currency)}
              <br></br>
            </span>
          ))}
        </h6>
      </div>
    );
  } else return null;
};
